/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ unlocked: NonNullable<unknown>, total: NonNullable<unknown> }} Profile_Showcase_Achievementscount1Inputs */

const id_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} pencapaian`)
};

const ms_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} pencapaian`)
};

const da_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} achievements`)
};

const de_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} Errungenschaften`)
};

const en_us2_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} achievements`)
};

const es_es2_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} logros`)
};

const es_mx2_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} logros`)
};

const fil_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} achievement`)
};

const fr_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} succès`)
};

const it_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} risultati`)
};

const hu_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} teljesítmény`)
};

const nl_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} prestaties`)
};

const no_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} prestasjoner`)
};

const pl_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} osiągnięć`)
};

const pt_br2_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conquistas ${i?.unlocked} / ${i?.total}`)
};

const pt_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} conquistas`)
};

const ro_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} realizări`)
};

const fi_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} saavutusta`)
};

const sv_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} prestationer`)
};

const vi_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} thành tích`)
};

const tr_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} başarım`)
};

const cs_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} úspěchů`)
};

const bg_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} постижения`)
};

const ru_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} достижений`)
};

const uk_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} досягнень`)
};

const ar_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} إنجاز`)
};

const hi_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} उपलब्धियाँ`)
};

const th_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} ความสำเร็จ`)
};

const ja_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} 実績`)
};

const zh_cn2_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} 项成就`)
};

const zh_hant1_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} 項成就`)
};

const ko_profile_showcase_achievementscount1 = /** @type {(inputs: Profile_Showcase_Achievementscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unlocked} / ${i?.total} 도전 과제`)
};

/**
* | output |
* | --- |
* | "{unlocked} / {total} achievements" |
*
* @param {Profile_Showcase_Achievementscount1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_showcase_achievementscount1 = /** @type {((inputs: Profile_Showcase_Achievementscount1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Showcase_Achievementscount1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_showcase_achievementscount1(inputs)
	if (locale === "ms") return ms_profile_showcase_achievementscount1(inputs)
	if (locale === "da") return da_profile_showcase_achievementscount1(inputs)
	if (locale === "de") return de_profile_showcase_achievementscount1(inputs)
	if (locale === "en-US") return en_us2_profile_showcase_achievementscount1(inputs)
	if (locale === "es-ES") return es_es2_profile_showcase_achievementscount1(inputs)
	if (locale === "es-MX") return es_mx2_profile_showcase_achievementscount1(inputs)
	if (locale === "fil") return fil_profile_showcase_achievementscount1(inputs)
	if (locale === "fr") return fr_profile_showcase_achievementscount1(inputs)
	if (locale === "it") return it_profile_showcase_achievementscount1(inputs)
	if (locale === "hu") return hu_profile_showcase_achievementscount1(inputs)
	if (locale === "nl") return nl_profile_showcase_achievementscount1(inputs)
	if (locale === "no") return no_profile_showcase_achievementscount1(inputs)
	if (locale === "pl") return pl_profile_showcase_achievementscount1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_showcase_achievementscount1(inputs)
	if (locale === "pt") return pt_profile_showcase_achievementscount1(inputs)
	if (locale === "ro") return ro_profile_showcase_achievementscount1(inputs)
	if (locale === "fi") return fi_profile_showcase_achievementscount1(inputs)
	if (locale === "sv") return sv_profile_showcase_achievementscount1(inputs)
	if (locale === "vi") return vi_profile_showcase_achievementscount1(inputs)
	if (locale === "tr") return tr_profile_showcase_achievementscount1(inputs)
	if (locale === "cs") return cs_profile_showcase_achievementscount1(inputs)
	if (locale === "bg") return bg_profile_showcase_achievementscount1(inputs)
	if (locale === "ru") return ru_profile_showcase_achievementscount1(inputs)
	if (locale === "uk") return uk_profile_showcase_achievementscount1(inputs)
	if (locale === "ar") return ar_profile_showcase_achievementscount1(inputs)
	if (locale === "hi") return hi_profile_showcase_achievementscount1(inputs)
	if (locale === "th") return th_profile_showcase_achievementscount1(inputs)
	if (locale === "ja") return ja_profile_showcase_achievementscount1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_showcase_achievementscount1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_showcase_achievementscount1(inputs)
	return ko_profile_showcase_achievementscount1(inputs)
});
export { profile_showcase_achievementscount1 as "profile.showcase.achievementsCount" }